module.exports = __webpack_public_path__ + "static/media/simonSound1.319c7710.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Simon/sounds/simonSound1.mp3
// module id = 86
// module chunks = 0